import catalog from './rsvRecommendCatalog.json';
import {createStageRecommendations} from './stageRecommendations';
const engine = createStageRecommendations(catalog);
export const getRsvRecommendedQuestion = engine.getQuestion;
export const getRsvRecommendedQuestions = engine.getQuestions;
export const completeRsvFreeTextRecommendations = engine.completeFreeText;
export default catalog;
